import { typed } from 'mathjs';

export const containsFunction = typed('contains', {
  '...': function (args: (string | number)[]) {
    const needle = args.pop();
    return needle !== undefined && args.includes(needle);
  }
});
